'use strict';

import update from 'immutability-helper';
var deepFreeze = require('deep-freeze')
import RowObj from '../helpers/row.js';
import FileUpload from '../components/builder/FileUpload.js';

const builderReducer = (state = {
	sidebar: {
		selectedTab:'components',
		visible:false,
		selectedElement:false,
		selectedRow:false,
		selectedSetting:false,
	},
	stop_on:'',
	status:0,

	ui: {
		'isHoveringRow':false,
		'isHoveringElement':false
	},

	page: {

	},

	components: {

	},

	elements:{

	},

	rows:{

	},
	tags:{},
	rules:{

	}
}, action) => {

	let newState = state;
	let updateSortOrder = {};
	let merge = {};
	let el = false;

	switch(action.type) {
		case 'BUILDER_SET_SIDEBAR_TAB':
			if(action.payload == state.sidebar.selectedTab) {
				return state;
			}
			newState = update(state,{
				sidebar: {
					["selectedTab"]: {
						$set:action.payload
					}

				}
			});

		break;

		case 'SET_TAG':
            newState = {
                ...state,
                tags:{
                    ...state.tags,
                    [action.payload.key]:action.payload.value
                }
            }
		break;

		case 'BUILDER_CHANGE_RULE':
			newState = {
				...state,
				rules:{
					...state.rules,
					[action.payload.index]:{
						...state.rules[action.payload.index],
						[action.payload.key]:action.payload.value,
					}
				}
			}

		break;

		case 'BUILDER_DELETE_ROW':

			merge = Object.keys(newState.rows)
			.filter(key => key != action.payload)
			.reduce((result, current) => {
				result[current] = newState.rows[current];
				return result;
			}, {});
			newState = {...newState,rows:merge};


		break;

		case 'BUILDER_SET_GLOBAL_KEY_STATE':
			newState = {
				...state,
				[action.payload.key]:action.payload.value
			}
		break;

		case 'BUILDER_DELETE_ELEMENT':

			newState = update(state,{
				rows: {
					[state.elements[action.payload].rowId]: {
						elements: {
							$splice: [[state.rows[state.elements[action.payload].rowId].elements.indexOf(action.payload), 1]]
						}
					}
				}
			});

			newState = {
				...newState,
				ui: {
					...newState.ui,
					isHoveringRow:false,
					isHoveringElement:false
				},
				sidebar: {
					...newState.sidebar,
					'visible':false,
					selectedRow:false,
					selectedElement:false,
				}
			}

			merge = Object.keys(newState.elements)
			.filter(key => key != action.payload)
			.reduce((result, current) => {
				result[current] = newState.elements[current];
				return result;
			}, {});
			newState = {...newState,elements:merge};


			merge = Object.keys(newState.components)
			.filter(key => key != action.payload)
			.reduce((result, current) => {
				result[current] = newState.components[current];
				return result;
			}, {});
			newState = {...newState,components:merge};

		break;

		case 'BUILDER_SET_SIDEBAR_STATE':
			merge = Object.assign({},state.sidebar,action.payload);

			newState = {
				...state,
				sidebar:merge
			}
		break;

		case 'BUILDER_SET_GLOBAL_TYPE_STATE':
			if(action.payload.id == false) {
				merge = Object.assign({},state[action.payload.key],action.payload.changes);

				newState = {
					...state,
					[action.payload.key]:merge
				}
			}else{
				merge = Object.assign({},state[action.payload.key][action.payload.id],action.payload.changes);

				newState = {
					...state,
					[action.payload.key]:{
						...state[action.payload.key],
						[action.payload.id]:merge
					}
				}
			}


		break;



		case 'BUILDER_SET_UI_STATE':
			merge = Object.assign({},state.ui,action.payload);

			newState = {
				...state,
				ui:merge
			}

		break;

		case 'BUILDER_SET_COMPONENT_STATE':
			merge = Object.assign({},state.components[action.payload.id],action.payload.changes);

			newState = {
				...state,
				components:{
					...state.components,
					[action.payload.id]:merge
				}
			}
		break;

		case 'BUILDER_ADD_ROW':
			newState = {
				...state,
				rows:{
					...state.rows,
					[action.payload.id]:{
						...state.rows[action.payload.id],
						type:'row'
					}
				}
			}

		break;



		case 'BUILDER_SET_SELECTED_ROW':
			newState = {
				...state,
				sidebar: {
					...state.sidebar,
					selectedRow:action.payload
				}
			};
		break;

		case 'BUILDER_CONVERT_TO_ELEMENT':
			newState = {
				...state,
				elements:{
					...state.elements,
					[action.payload.element.id]:action.payload.element
				}
			}

			newState = {
				...newState,
				components:{
					...newState.components,
					[action.payload.element.id]:action.payload.el.output()
				}
			}


		break;

		case 'BUILDER_REMOVE_ELEMENT':
			if(!rowExists(state,action.payload.rowId)) {
				return state;
			}

			newState = update(state,{
				rows: {
					[action.payload.rowId]: {
						elements: {
							$splice: [[state.rows[action.payload.rowId].elements.indexOf(action.payload.id), 1]]
						}
					}
				}
			});

			Object.keys(newState)
			.filter(key => key !== action.payload.id)
			.reduce((result, current) => {
				result[current] = newState[current];
				return result;
			}, {});

		break;

		case 'BUILDER_MOVE_ELEMENT':
			deepFreeze(state);

			const old_row_id = state.elements[action.payload.newPosition.id].rowId;
			const old_col_id = state.elements[action.payload.newPosition.id].col;

			updateSortOrder = {};
			for(let i in action.payload.newSorting.list) {
				updateSortOrder[i] = {
					sorting: {
						$set:action.payload.newSorting.list[i]
					}
				}
			}
			newState = update(state,{
				elements: updateSortOrder
			});




			let draggedElement = {};
			let hoveredElement= {};




			//Add element if its not in column
			if(typeof action.payload.newSorting.list[action.payload.newPosition.id] === 'undefined') {
				newState = update(state,{
					elements: {
						[action.payload.newPosition.id]: {
							sorting: {
								$set:action.payload.newPosition.sorting
							},
							rowId: {
								$set:action.payload.newPosition.rowId
							},
							col: {
								$set:action.payload.newPosition.col
							}
						}
					}
				});
			}

			if(action.payload.newPosition.rowId != old_row_id || action.payload.newPosition.col != old_col_id ) {
				newState = update(newState,{
					rows: {
						[old_row_id]: {
							elements: {
								$splice: [[newState.rows[old_row_id].elements.indexOf(action.payload.newPosition.id), 1]]
							}
						}
					}
				});

				newState = update(newState,{
					rows: {
						[action.payload.newPosition.rowId]: {
							elements: {
								$push:[action.payload.newPosition.id]
							}
						}
					}
				});
			}




/*
			if(action.payload.hover.id !== false) {
				newState = update(newState,{
					elements: {
						[action.payload.hover.id]: {
							sorting: {
								$set:action.payload.drag.index
							}
						}
					}
				});
			}


			*/
		break;

		case 'BUILDER_ADD_PLACEHOLDER':

			updateSortOrder = {};
			for(let i in action.payload.newSorting.list) {
				updateSortOrder[i] = {
					sorting: {
						$set:action.payload.newSorting.list[i]
					}
				}
			}
			newState = update(state,{
				elements: updateSortOrder
			});



			newState = {
				...newState,
				elements:{
					...newState.elements,
					[action.payload.newPosition.id]:action.payload.newPosition
				}
			}

			newState = update(newState,{
				rows: {
					[action.payload.newPosition.rowId]: {
						elements: {
							$push:[action.payload.newPosition.id]
						}
					}
				}
			});
		break;

		case 'BUILDER_ADD_ROW_PLACEHOLDER':
			updateSortOrder = {};
			for(let i in action.payload.newSorting.list) {
				updateSortOrder[i] = {
					sorting: {
						$set:action.payload.newSorting.list[i]
					}
				}
			}
			newState = update(state,{
				rows: updateSortOrder
			});

			let newRow = new RowObj(false);
			newRow.item.type = 'placeholder';
			newRow.item.id = action.payload.newPosition.id;
			newRow.item.sorting = action.payload.newPosition.sorting;
			newRow.item.columns = action.payload.newPosition.columns;

			newState = {
				...newState,
				rows:{
					...newState.rows,
					[action.payload.newPosition.id]:newRow.output()
				}
			}

		break;

		case 'BUILDER_MOVE_ROW':
			updateSortOrder = {};
			for(let i in action.payload.newSorting.list) {
				updateSortOrder[i] = {
					sorting: {
						$set:action.payload.newSorting.list[i]
					}
				}
			}
			newState = update(state,{
				rows: updateSortOrder
			});

		break;
	}

	return newState;
}

function rowExists(state,rowId) {
	if(typeof state.rows[rowId] === 'undefined') {
		return false;
	}

	return true;
}

function elementExists(state,elementId) {

}

export default builderReducer;



// WEBPACK FOOTER //
// ./reducers/builderReducer.js